module.exports = __webpack_public_path__ + "img/instructor_img5.50c31ff3.png";